import { useNavigate } from "react-router-dom";

export const AuthModal = ({ open, onClose }) => {
  const navigate = useNavigate();

  if (!open) return null;

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[9998]"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed inset-0 flex items-center justify-center z-[9999] px-4">
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md relative animate-fade-in">
          {/* Close Button */}
          <button
            className="absolute top-3 right-4 text-2xl text-gray-600 hover:text-black"
            onClick={onClose}
          >
            ×
          </button>

          {/* Content */}
          <div className="p-8 text-center">
            <h3 className="text-xl font-semibold mb-3">Sign in to save</h3>

            <p className="text-gray-600 text-sm mb-8">
              Save properties to your account and sync across devices.
            </p>

            <div className="flex gap-4">
              <button
                onClick={() => navigate("/sign-up")}
                className="flex-1 border-2 border-[#097FE6] text-[#097FE6] py-3 rounded-xl font-semibold hover:border-[#178df5] transition"
              >
                Join
              </button>

              <button
                onClick={() => navigate("/log-in")}
                className="flex-1 bg-[#097FE6]  text-white py-3 rounded-xl font-semibold hover:bg-[#178df5] transition"
              >
                Sign in
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
